import React, { useEffect } from 'react';
import '../assets/css/Pastel.css';
import './Legal.css';

const Legal: React.FC = () => {
  useEffect(() => {
    document.title = 'Nond';
  }, []);
  return (
    <div className="legal-root">
      <div className="legal-container">
        <h1>Legal Disclaimer and Terms for Nond</h1>

        <p className="legal-lead">
          These terms govern your use of the Nond web pages, applications, and services (collectively, the "Service"). Please read this disclaimer carefully. By accessing or using the Service you agree to be bound by these terms.
        </p>

        <h2>1. No Professional Advice</h2>
        <p>
          Content provided by Nond, including recipes, nutritional information, meal plans, grocery lists, and recommendations, is for informational and convenience purposes only. Nothing on the Service constitutes medical, nutritional, dietary, legal, or other professional advice. You should consult a qualified professional for any specific medical, nutritional, or other advice related to allergies, intolerances, medical conditions, pregnancy, or other special dietary needs.
        </p>

        <h2>2. Accuracy and Reliability</h2>
        <p>
          Nond strives to provide accurate and up-to-date recipe content and functionality. However, we do not warrant or guarantee the completeness, reliability, accuracy, suitability, or availability of the information presented. Ingredients, instructions, times, and measurements may contain errors, omissions, or typographical mistakes. You use the Service at your own risk.
        </p>

        <h2>3. Allergens and Food Safety</h2>
        <p>
          Recipes or imported content may not list every possible allergen or cross-contamination risk. If you or someone for whom you are cooking has allergies or specific dietary restrictions, carefully review ingredient lists and preparation instructions before use. Nond is not responsible for adverse reactions to food prepared using recipes from the Service.
        </p>

        <h2>4. Third-Party Content and Links</h2>
        <p>
          The Service may include content sourced from third parties and links to external websites. Nond does not control, endorse, or guarantee the accuracy of any third-party content. We are not responsible for the practices, products, terms, or privacy policies of third-party websites. Accessing third-party links is at your own risk.
        </p>

        <h2>5. Importing and Scraping Content</h2>
        <p>
          When you import recipes from third-party websites, Nond attempts to capture key fields such as title, ingredients, and instructions. Imported content often originates on external sites and is reproduced within your personal Nond cookbook for convenience. You are responsible for ensuring that you have the legal right to import or reproduce any content and for complying with the terms of use of the source website. Nond disclaims any liability for copyright or usage claims arising from imported content.
        </p>

        <h2>6. Intellectual Property</h2>
        <p>
          All original content created by Nond (text, graphics, code, trademarks, logos) remains the property of Nond or its licensors. When you upload or submit content to the Service (including recipes, photos, or notes), you grant Nond a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, distribute, and display that content in connection with providing and promoting the Service. Do not upload or submit content that you do not have the right to share.
        </p>

        <h2>7. User Accounts and Responsibility</h2>
        <p>
          If the Service allows creation of a user account, you are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately of any unauthorized use. We reserve the right to suspend or terminate accounts that violate these terms or pose a security risk.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by applicable law, Nond, its affiliates, officers, directors, employees, agents, and licensors will not be liable for any indirect, incidental, special, consequential, punitive, or exemplary damages, including but not limited to lost profits, lost data, personal injury, or other intangible losses arising from your use of the Service, even if Nond has been advised of the possibility of such damages.
        </p>

        <h2>9. Warranties</h2>
        <p>
          THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE. Nond DISCLAIMS ALL WARRANTIES, INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>

        <h2>10. Indemnification</h2>
        <p>
          You agree to indemnify, defend, and hold harmless Nond and its affiliates from and against any claims, liabilities, damages, losses, and expenses (including reasonable legal fees) arising out of or in any way connected with your use of the Service, your violation of these terms, or your violation of any rights of another.
        </p>

        <h2>11. Privacy</h2>
        <p>
          Nond's Privacy Policy governs how we collect, use, and disclose personal information. Review the Privacy Policy to understand our data practices. By using the Service you consent to those practices.
        </p>

        <h2>12. Modifications to the Service and Terms</h2>
        <p>
          Nond may modify, suspend, or discontinue the Service (or any feature) at any time without prior notice. We may also update this disclaimer and terms from time to time. Material changes will be communicated as appropriate. Your continued use of the Service after changes constitute acceptance of the updated terms.
        </p>

        <h2>13. Governing Law and Dispute Resolution</h2>
        <p>
          These terms are governed by the laws of the jurisdiction where Nond is incorporated or operates, without regard to conflict of law principles. Any dispute arising out of or relating to these terms will be resolved in the applicable courts of that jurisdiction, unless the parties agree to arbitration.
        </p>

        <h2>14. Contact</h2>
        <p>
          If you have questions about this disclaimer or want to report content concerns, contact us at the address or email provided on the Service. We'll make reasonable efforts to respond and address issues.
        </p>

        <p className="legal-note">
          Last updated: December 13, 2025
        </p>
      </div>
    </div>
  );
};

export default Legal;
